import React, { createContext, useReducer } from 'react'

//Types
import {Format, Action} from 'types/cas'

//Util
import { CAS_LANGUAGE_LOCAL_STORAGE_KEY } from 'util/constants'

// Hooks
import { useLocalStorage } from 'hooks'

function reducer(state:Format[], action:Action) {
  const { type, value } = action
  switch (type) {
    case 'add': {
      return state.concat(value!)
    }
    case 'clear': {
      return []
    }
  }
}

export const CasFormatState = createContext<Format[]>([])

export const CasFormatDispatch = createContext<React.Dispatch<Action>>((action:Action) => {})

export const CasFormatProvider = ({children}:any) => {
  const [state, dispatch] = useReducer(reducer, [])

  return (
    <CasFormatState.Provider value={state}>
      <CasFormatDispatch.Provider value={dispatch}>
        {children}
      </CasFormatDispatch.Provider>
    </CasFormatState.Provider>
  )
}

export const CasLanguageState = createContext<string>("SAS")
export const CasLanguageDispatch = createContext<(value: string)=>void>((value: string) => {})

export const CasLanguageProvider = ({ children }:any) => {
  const [casLanguage, setCasLanguage] = useLocalStorage<string>(CAS_LANGUAGE_LOCAL_STORAGE_KEY, 'SAS')

  return (
    <CasLanguageState.Provider value={casLanguage}>
      <CasLanguageDispatch.Provider value={setCasLanguage}>
        { children }
      </CasLanguageDispatch.Provider>
    </CasLanguageState.Provider>
  )
}
  
